export const REQUEST_TIMEOUT_ERROR_NAME = 'RequestTimeoutError';

function createTimeoutError(message: string): Error {
    const error = new Error(message);
    error.name = REQUEST_TIMEOUT_ERROR_NAME;
    return error;
}

export function isRequestTimeoutError(error: unknown): boolean {
    return error instanceof Error && error.name === REQUEST_TIMEOUT_ERROR_NAME;
}

export function withTimeout<T>(
    promise: PromiseLike<T>,
    timeoutMs: number,
    message: string
): Promise<T> {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const timeoutPromise = new Promise<never>((_, reject) => {
        timeoutId = setTimeout(() => reject(createTimeoutError(message)), timeoutMs);
    });

    return Promise.race([Promise.resolve(promise), timeoutPromise]).finally(() => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    });
}
